/** Formatea fecha calendario (YYYY-MM-DD o ISO) sin corrimiento por zona horaria. */
export const formatFechaCorta = (value) => {
  if (!value) return '—';
  const s = String(value).slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const [y, m, d] = s.split('-');
    return `${d}/${m}/${y}`;
  }
  return s;
};

export const parseFechaCalendario = (value) => {
  if (!value) return null;
  const s = String(value).slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(s) ? s : null;
};
